import(/* webpackMode: "eager" */ "/app/src/app/gdpr-compliance/page.tsx");
